import React, { useEffect, useState } from "react";
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Menu,
  MenuItem,
  Grid,
  Typography,
  CircularProgress,
  Autocomplete,
  TextField,
  Box,
  Stack,
  IconButton,
  FormControlLabel,
  Chip,
  alpha,
} from "@mui/material";
import HomeLayout from "../../asset/layout/HomeLayout";
import { ArrowDropDownCircleOutlined, Check, Edit } from "@mui/icons-material";

import DropDownMenu from "../../components/mui/DropDownMenu";
import SearchBar from "../../components/mui/SearchBar";
import Paginations from "../../components/mui/Pagination";
import { useDispatch } from "react-redux";
import {
  getAllBrands,
  parseBrandsPageResponse,
  updateBrand,
  updateBrandDiscount,
  uploadDocument,
} from "../../actions/brandsAuth";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { enqueueSnackbar } from "notistack";
import IOSSwitch from "../../style/globalStyles";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/mui/CustomButton";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import dayjs from "dayjs";
const columns = [
  "Brand Id",
  " Brand Image",
  "Brand Name",
  "Important Instruction",
  "Online Redemption URL",
  "Siripay Discount",
  "Min Denomination",
  "Max Denomination",
  "Brand Product Code",
  "Brand Type",
  "Stock Availability",
  "Created At",
  "Updated At",

  "Category Name",
  "Active Staus",
];

const menuItems = [{ label: "Deposit" }, { label: "Withdraw" }];

const BRAND_CATEGORIES = [
  "Food",
  "Quick Commerce",
  "Jewellary",
  "Grocery",
  "E-Commerce",
  "E-commerce",
  "Travel",
  "LifeStyle",
  "Entertainment",
  "Pharmacy",
  "Electronics",
];

export default function PremiumCardsManagement() {
  const [allbrands, setAllBrands] = useState(0);

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [countPerPage, setCountPerPage] = useState(10);
  const [tempDiscountIndex, setTempDiscountIndex] = useState("");
  const [tempDiscount, setTempDiscount] = useState("");
  const [brands, setBrands] = useState([]);
  const [exporting, setExporting] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 400);
    return () => clearTimeout(handler);
  }, [searchTerm]);

  const handleSearch = (term) => {
    setSearchTerm(term);
    setCurrentPage(1);
  };
  const dispatch = useDispatch();
  const [tempImages, setTempImages] = useState([]);
  const Navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      Navigate("/");
    }
  }, []);

  const fetchAllBrandsForExport = (onComplete) => {
    const pageSize = 100;
    const search = debouncedSearch.trim() || undefined;

    const fetchPage = (page, accumulated = []) => {
      dispatch(
        getAllBrands(
          { page, size: pageSize, search },
          (data) => {
            const parsed = data?.parsed ?? parseBrandsPageResponse(data);
            const merged = [...accumulated, ...parsed.content];
            const hasMore =
              merged.length < parsed.totalElements &&
              parsed.content.length === pageSize;

            if (hasMore) {
              fetchPage(page + 1, merged);
              return;
            }

            onComplete(merged);
          },
          (err) => {
            console.error(err);
            onComplete(accumulated);
          }
        )
      );
    };

    fetchPage(0);
  };

  const fetchBrands = () => {
    setLoading(true);
    const query = debouncedSearch.trim();
    dispatch(
      getAllBrands(
        {
          page: Math.max(currentPage - 1, 0),
          size: Number(countPerPage),
          search: query || undefined,
        },
        (data) => {
          const parsed = data?.parsed ?? parseBrandsPageResponse(data);
          let content = parsed.content || [];
          let total = parsed.totalElements;

          // Client-side fallback: if a search query is active, verify that returned
          // items match query or filter if backend returned unfiltered items
          if (query) {
            const lowerQuery = query.toLowerCase();
            const matchesQuery = (b) => {
              const name = String(b.brandName || b.BrandName || "").toLowerCase();
              const code = String(b.brandProductCode || b.BrandProductCode || "").toLowerCase();
              const type = String(b.brandType || b.Brandtype || b.BrandType || "").toLowerCase();
              const cat = Array.isArray(b.category || b.Category)
                ? (b.category || b.Category).join(" ").toLowerCase()
                : String(b.category || b.Category || "").toLowerCase();
              const id = String(b.id || b._id || "").toLowerCase();
              return (
                name.includes(lowerQuery) ||
                code.includes(lowerQuery) ||
                type.includes(lowerQuery) ||
                cat.includes(lowerQuery) ||
                id.includes(lowerQuery)
              );
            };
            const filtered = content.filter(matchesQuery);
            if (filtered.length > 0 && filtered.length !== content.length) {
              content = filtered;
              total = filtered.length;
            }
          }

          setBrands(content);
          setAllBrands(total);
          setLoading(false);
        },
        (err) => {
          console.error(err);
          setLoading(false);
        }
      )
    );
  };

  useEffect(() => {
    fetchBrands();
  }, [debouncedSearch, countPerPage, currentPage, dispatch]);

  const exportToExcel = () => {
    setExporting(true);
    fetchAllBrandsForExport((brandsToExport) => {
      const header = [
      "Brand Name",
      "Siripay Discount",
      "Denomination List",
      "Brand Product Code",
      "Brand Type",
      "Stock Availability",
      "Date Added",
      "Category Name",
      "Active Status",
    ];

    const truncateString = (str, maxLength = 32767) => {
      if (typeof str !== "string") {
        return str;
      }
      return str.length > maxLength
        ? str.substring(0, maxLength - 3) + "..."
        : str;
    };

    const dataToExport = brandsToExport.map((brand) => [
      truncateString(brand.BrandName || ""),
      brand.discount || "",
      truncateString(
        brand.denominationList ? brand.denominationList.join(", ") : "--"
      ),
      truncateString(brand.BrandProductCode || ""),
      truncateString(brand.BrandType || ""),
      brand.stockAvailable ? "Available" : "Out of stock",
      brand.createdAt ? new Date(brand.createdAt).toLocaleDateString() : "--",
      truncateString(brand.Category ? brand.Category.join(", ") : "--"),
      brand.isPremium ? "Active" : "Inactive",
    ]);

    dataToExport.unshift(header);

    const worksheet = XLSX.utils.aoa_to_sheet(dataToExport);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Brands Data");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(blob, "brands_data.xlsx");
    setExporting(false);
    });
  };

  const [isEditing, setIsEditing] = useState(null);
  const [tempImage, setTempImage] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);

  const handleEditClick = (row, index) => {
    if (isEditing === index) {
      if (selectedImage) {
        uploadImage(selectedImage, index, row);
      }
      setIsEditing(null);
    } else {
      setTempImage(getBrandField(row, "brandImage", "BrandImage"));
      setIsEditing(index);
      document.getElementById(`file-input-${index}`).click();
    }
  };

  const handleFileChange = (e, index) => {
    if (e.target.files && e.target.files[0]) {
      const fileName = e.target.files[0].name.toLowerCase();
      if (
        fileName.includes("jpg") ||
        fileName.includes("jpeg") ||
        fileName.includes("png")
      ) {
        setSelectedImage(e.target.files[0]);
        setTempImage(URL.createObjectURL(e.target.files[0]));
        setIsEditing(index);
      } else {
        enqueueSnackbar("Please upload a valid image", { variant: "warning" });
      }
    }
  };

  const uploadImage = (file, index, row) => {
    let formData = new FormData();
    formData.append("file", file);
    dispatch(
      uploadDocument(
        formData,
        (data) => {
          const newImageUrl = data?.data?.data?.publicUrl;
          updateBrandStatus(row, { brandImage: newImageUrl });
        },
        (err) => {
          console.log(err);
        }
      )
    );
  };

  const updateBrandStatus = (row, overrides = {}) => {
    const brandId = getBrandField(row, "id", "_id");
    const payload = {
      brandName: getBrandField(row, "brandName", "BrandName"),
      brandType: getBrandField(row, "brandType", "Brandtype", "BrandType"),
      onlineRedemptionUrl: getBrandField(row, "onlineRedemptionUrl"),
      brandImage: getBrandField(row, "brandImage", "BrandImage"),
      stockAvailable: Boolean(row?.stockAvailable),
      minDenomination: getBrandField(row, "minDenomination"),
      maxDenomination: getBrandField(row, "maxDenomination"),
      category: row?.category || row?.Category || [],
      descriptions: getBrandField(row, "descriptions"),
      tnc: getBrandField(row, "tnc"),
      importantInstruction: getBrandField(row, "importantInstruction"),
      discount: Number(getBrandField(row, "discount")) || 0,
      isActive: Boolean(row?.isActive),
      isPremium: Boolean(row?.isPremium),
      ...overrides,
    };
    dispatch(
      updateBrand(
        brandId,
        payload,
        (data) => {
          enqueueSnackbar("Brand Updated Successfully", { variant: "success" });
          fetchBrands();
        },
        (error) => {
          const errorMessage =
            typeof error?.response?.data?.message === "string" &&
            error?.response?.data?.message?.trim()
              ? error.response.data.message
              : "Failed to update brand";
          enqueueSnackbar(errorMessage, { variant: "error" });
          console.log(error);
        }
      )
    );
  };

  const getBrandField = (row, ...keys) => {
    for (const key of keys) {
      if (row?.[key] !== undefined && row?.[key] !== null && row?.[key] !== "") {
        return row[key];
      }
    }
    return "--";
  };

  const updateDiscountById = (row, discountValue) => {
    const brandId = getBrandField(row, "id", "_id");
    dispatch(
      updateBrandDiscount(
        brandId,
        { discount: Number(discountValue) || 0 },
        () => {
          enqueueSnackbar("Discount Updated Successfully", { variant: "success" });
          setTempDiscountIndex("");
          fetchBrands();
        },
        (error) => {
          const errorMessage =
            typeof error?.response?.data?.message === "string" &&
            error?.response?.data?.message?.trim()
              ? error.response.data.message
              : "Failed to update discount";
          enqueueSnackbar(errorMessage, {
            variant: "error",
          });
        }
      )
    );
  };
  return (
    <>
      <Box sx={{ mt: 3 }}>
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent={"space-between"}
        >
          <Grid item md={6} xs={12}>
            <SearchBar
              onSearch={handleSearch}
              searchTerm={searchTerm}
              onClear={() => handleSearch("")}
              sWidth={"100%"}
              height="2.75rem"
              placeholder="Search by brand name, product code, or category..."
            />
            {searchTerm.trim() ? (
              <Typography variant="body2" sx={{ mt: 1, color: "#64748b" }}>
                {allbrands} brand{allbrands === 1 ? "" : "s"} match your search
              </Typography>
            ) : null}
          </Grid>
          <Grid item md={6} xs={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: { md: "end", xs: "start" },
                width: "100%",
              }}
            >
              {" "}
              <CustomButton
                variant="contained"
                width={{ md: "22%", sm: "50%", xs: "40%" }}
                height={"rem"}
                type="button"
                onClick={exportToExcel}
              >
                Export All
              </CustomButton>
            </Box>
          </Grid>
        </Grid>
        {loading ? (
          <Typography textAlign={"center"} my={2}>
            <CircularProgress size={24} />
          </Typography>
        ) : (
          <TableContainer
            component={Paper}
            sx={{
              borderRadius: "25px",
              overflowX: "scroll",
              my: 3,
            }}
          >
            <Table sx={{ maxWidth: "auto" }}>
              <TableHead>
                <TableRow>
                  {columns.map((column, index) => (
                    <TableCell
                      key={index}
                      sx={{
                        fontSize: "16px",
                        fontWeight: "500",
                        color: "#11409B",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                      }}
                    >
                      {column}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody
                sx={{
                  whiteSpace: "nowrap",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                {brands.length > 0 ? (
                  brands.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{getBrandField(row, "id", "_id")}</TableCell>
                      <TableCell>
                        <Box sx={{ border: "1px solid #E5E4E2" }}>
                          <img
                            src={
                              isEditing === index
                                ? tempImage
                                : getBrandField(row, "brandImage", "BrandImage")
                            }
                            alt={getBrandField(row, "brandName", "BrandName")}
                            style={{
                              width: "7rem",
                              height: "4rem",
                              objectFit: "fill",
                            }}
                          />
                          <input
                            type="file"
                            id={`file-input-${index}`}
                            style={{ display: "none" }}
                            accept="image/*"
                            onChange={(e) => handleFileChange(e, index)}
                          />
                          <IconButton
                            onClick={() => handleEditClick(row, index)}
                          >
                            {isEditing === index ? <Check /> : <Edit />}
                          </IconButton>
                        </Box>
                      </TableCell>

                      <TableCell>{getBrandField(row, "brandName", "BrandName")}</TableCell>
                      <TableCell sx={{ maxWidth: 280, whiteSpace: "normal" }}>
                        {getBrandField(row, "importantInstruction")}
                      </TableCell>
                      <TableCell sx={{ maxWidth: 220, whiteSpace: "normal" }}>
                        {getBrandField(row, "onlineRedemptionUrl")}
                      </TableCell>
                      <TableCell>
                        <TextField
                          placeholder="Enter discount"
                          value={
                            tempDiscountIndex === index
                              ? tempDiscount
                              : getBrandField(row, "discount")
                          }
                          onChange={(e) => setTempDiscount(e.target.value)}
                          disabled={tempDiscountIndex !== index}
                          InputProps={{
                            endAdornment:
                              tempDiscountIndex === index ? (
                                <Check
                                  sx={{
                                    fontSize: "16px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    updateDiscountById(row, tempDiscount)
                                  }
                                />
                              ) : (
                                <Edit
                                  sx={{
                                    fontSize: "16px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setTempDiscount(getBrandField(row, "discount"));
                                    setTempDiscountIndex(index);
                                  }}
                                />
                              ),
                          }}
                        />
                      </TableCell>

                      <TableCell>{getBrandField(row, "minDenomination")}</TableCell>
                      <TableCell>{getBrandField(row, "maxDenomination")}</TableCell>
                      <TableCell>{getBrandField(row, "brandProductCode", "BrandProductCode")}</TableCell>
                      <TableCell>{getBrandField(row, "brandType", "Brandtype", "BrandType")}</TableCell>
                      <TableCell>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Chip
                            label={row?.stockAvailable ? "In stock" : "Out of stock"}
                            size="small"
                            sx={{
                              fontWeight: 700,
                              color: row?.stockAvailable ? "#16a34a" : "#dc2626",
                              bgcolor: row?.stockAvailable
                                ? alpha("#16a34a", 0.12)
                                : alpha("#dc2626", 0.12),
                            }}
                          />
                          <FormControlLabel
                            control={
                              <IOSSwitch
                                checked={Boolean(row.stockAvailable)}
                                onChange={(e) =>
                                  updateBrandStatus(row, {
                                    stockAvailable: e.target.checked,
                                  })
                                }
                              />
                            }
                            label=""
                            sx={{ m: 0 }}
                          />
                        </Stack>
                      </TableCell>
                      <TableCell>
                        {row?.createdAt
                          ? dayjs(row?.createdAt).format("MM-DD-YYYY ")
                          : ""}
                      </TableCell>
                      <TableCell>
                        {row?.updatedAt
                          ? dayjs(row?.updatedAt).format("MM-DD-YYYY ")
                          : ""}
                      </TableCell>

                      <TableCell>
                        <Autocomplete
                          id="combo-box-demo"
                          value={row?.Category}
                          multiple
                          onChange={(event, newValue) => {
                            updateBrandStatus(row, { category: newValue });
                          }}
                          options={BRAND_CATEGORIES}
                          sx={{ width: 300 }}
                          renderInput={(params) => (
                            <TextField {...params} label="Category" />
                          )}
                        />
                      </TableCell>

                      <TableCell>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          {" "}
                          <FormControlLabel
                            control={
                              <IOSSwitch
                                checked={row.isPremium}
                                onChange={(e) => {
                                  updateBrandStatus(row, {
                                    isPremium: e.target.checked,
                                  });
                                }}
                              />
                            }
                          />
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center" sx={{ py: 6 }}>
                      <Typography variant="h6" color="text.secondary">
                        {debouncedSearch
                          ? `No brands found matching "${debouncedSearch}"`
                          : "No data found"}
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
        <Box
          sx={{
            bgcolor: "mute.dark",
            borderRadius: 1,
            color: "dark.text",
            p: 2,
            mt: 4,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography>
              {allbrands === 0
                ? "0 of 0"
                : `${(currentPage - 1) * countPerPage + 1} - ${Math.min(
                    currentPage * countPerPage,
                    allbrands
                  )} of ${allbrands}`}
            </Typography>
          </Box>
          <Box sx={{ display: "flex" }}>
            <Typography> Rows per page:</Typography>
            <select
              style={{
                marginTop: "-5px",
                background: "transparent",
                border: "none",
              }}
              value={countPerPage}
              onChange={(e) => {
                setCountPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="30">30</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
            <Box sx={{ ml: 2 }}>
              <Stack
                direction={"row"}
                spacing={2}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Box>
                  <IconButton
                    onClick={() => setCurrentPage(currentPage - 1)}
                    disabled={currentPage <= 1 || countPerPage > allbrands}
                    sx={{
                      border: "1px solid",
                      borderRadius: "10px",
                      borderColor: "mute.main",
                      bgcolor: "white.main",
                      boxShadow: "2px 2px 0px #999",
                      background: "#fff",
                    }}
                  >
                    <KeyboardArrowLeftIcon
                      sx={{
                        fontSize: "15px",
                        fontWeight: "bold",
                        color:
                          currentPage <= 1 || countPerPage > allbrands
                            ? "#999"
                            : "#000",
                      }}
                    />
                  </IconButton>
                </Box>
                <Box>
                  <Typography variant="text" component={"span"}>
                    {allbrands === 0
                      ? "1/1"
                      : `${currentPage}/${Math.max(
                          Math.ceil(allbrands / countPerPage),
                          1
                        )}`}
                  </Typography>
                </Box>
                <Box>
                  <IconButton
                    onClick={() => setCurrentPage(currentPage + 1)}
                    disabled={
                      allbrands === 0 ||
                      countPerPage > allbrands ||
                      currentPage >= Math.ceil(allbrands / countPerPage)
                    }
                    sx={{
                      border: "1px solid",
                      borderRadius: "10px",
                      borderColor: "mute.main",
                      bgcolor: "white.main",
                      boxShadow: "2px 2px 0px #999",
                      background: "#fff",
                    }}
                  >
                    <KeyboardArrowRightIcon
                      sx={{
                        fontSize: "15px",
                        fontWeight: "bold",
                        color: "#000",
                      }}
                    />
                  </IconButton>
                </Box>
              </Stack>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
